module.exports = __webpack_public_path__ + "img/l5.5d7b42ce.jpg";